import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MatButtonToggleDefaultOptions } from '@angular/material/button-toggle';
import { Provider } from '@angular/core';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

const buttonToggle: MatButtonToggleDefaultOptions = {
  hideSingleSelectionIndicator: true,
  hideMultipleSelectionIndicator: true,
};

const tabsConfig: MatTabsConfig = {
  animationDuration: '0ms',
  stretchTabs: false,
};

export function provideMaterialTheme(): Provider[] {
  return [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { position: 'above' },
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_CARD_CONFIG, useValue: { appearance: 'outlined' } },
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: buttonToggle,
    },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    {
      provide: MAT_TABS_CONFIG,
      useValue: tabsConfig,
    },
  ];
}
